<section class="article">
  <article>
    <h2>Fehler: Die gesuchte Datei kann nicht gefunden werden</h2>
    <p>
      Der von Ihnen genutzte Download-Link ist nicht oder nicht mehr gültig.
      Bitte prüfen Sie Ihre Eingabe bzw. fordern Sie einen neuen Link an.
    </p>
    <a class="call" [routerLink]="['/download']">Zur Download-Seite</a>
  </article>
</section>
